import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';

import { DialogAngularModule } from 'rev-shared/ui/dialog/DialogAngular.Module';
import { SparkModule } from 'rev-portal/media/spark/Spark.Module';
import { SpinnerAngularModule } from 'rev-shared/ui/spinner/SpinnerAngular.Module';
import { VbUiTextInputDirective } from 'rev-shared/ui/textInput/VbUiTextInput.Directive';

import { WebexTeamsComponent } from './WebexTeams.Component';

@NgModule({
	declarations: [
		WebexTeamsComponent
	],
	exports: [
		WebexTeamsComponent
	],
	imports: [
		CommonModule,
		DialogAngularModule,
		FormsModule,
		SparkModule,
		SpinnerAngularModule,
		TranslateModule,
		TypeaheadModule,
		VbUiTextInputDirective
	]
})

export class WebexTeamsModule {
}
